'use client'; // Error components must be Client Components
import { Button, Flex, Stack, Text } from '@chakra-ui/react';
import * as Sentry from '@sentry/nextjs';
import Image from 'next/image';
import Link from 'next/link';
import { useEffect } from 'react';

import errorStatus from '@/assets/images/error_status.png';
import BrandLogo from '@/assets/images/Logo_Cedars.svg';
import { CONTACT_US_EMAIL } from '@/constants/common';
import { useTranslation } from '@/i18n/client';

export default function Error({ error }: { error?: Error & { digest?: string }; reset?: () => void }) {
  const { t } = useTranslation();
  useEffect(() => {
    Sentry.captureException(error);
    console.error(error);
  }, [error]);

  return (
    <Stack align='center' justifyContent='center' height={'100vh'} gap={8}>
      <Image width={160} src={BrandLogo} alt='Brand Logo' />
      <Stack gap={4} maxW={'40rem'} align='center' justifyContent='center'>
        <Image src={errorStatus} alt='error_status' />
        <Text fontWeight={600} fontSize={'1.875rem'} lineHeight={'2.25rem'}>
          {t('common.errorTitle')}
        </Text>
        <Text fontSize={'1rem'} lineHeight={'1.5rem'} color={'gray.200'}>
          {error?.message ? `Error Code: ${error.message}` : ''}
        </Text>
        <Stack color={'gray.500'}>
          <Text
            dangerouslySetInnerHTML={{ __html: t('common.webpageNotFound', { supportEmail: CONTACT_US_EMAIL }) }}
          ></Text>
        </Stack>
        <Flex gap={4}>
          <Link href={`mailto:${CONTACT_US_EMAIL}`} target='_blank'>
            <Button colorScheme='blue' variant='outline' size='lg'>
              {t('account-management.contactUs')}
            </Button>
          </Link>
          <Button colorScheme='blue' size='lg' onClick={() => window.history.back()}>
            {t('common.return')}
          </Button>
        </Flex>
      </Stack>
    </Stack>
  );
}
